import { Icon } from './Icon';
import { Tooltip, type TooltipPosition } from './Tooltip';
import './InfoHint.scss';

/**
 * Design review 2 Nov 2026: the long read-only / "please edit" explanations at the top of a page become one small info icon;
 * the text shows on hover or keyboard focus. The tooltip text is also the button's accessible name.
 */
export function InfoHint({ text, placement = 'below' }: { text: string; placement?: TooltipPosition }) {
  return (
    <Tooltip title={text} placement={placement}>
      <button type="button" className="kit-info-hint">
        <Icon name="info" outlined />
      </button>
    </Tooltip>
  );
}
